module.exports = __webpack_public_path__ + "img/three-dimensional.2c26bd02.png";